import CustomIcon from "components/CustomIcon";
import {setManageBlogModals} from "../../../redux/slices/manageBlogSlice";
import {useDispatch} from "react-redux";

const BlogTag = ({ tag, className = ""}) => {
  const dispatch = useDispatch();
  const loading = !tag;


  const onTagsEdit = () => {
    if (!loading)
      dispatch(setManageBlogModals({
        modal: true,
        isTag: true,
        data: tag
      }));
  };

  const onTagDelete = (e) => {
    e.stopPropagation();
    if (!loading)
      dispatch(setManageBlogModals({
        modal: true,
        isConfirm: true,
        data: {delete: tag}
      }));
  };

  return (
    <div
      className={`rounded border p-1.5 text-dark text-sm flex justify-between items-start space-x-1.5 items-center mr-1 mb-1 bg-neutral 2xl:h-14${className ? ` ${className}` : ''}`}>
      <span className="text-2-clamp">{tag?.title ?? "...."}</span>
      <div className="flex space-x-2">
        <CustomIcon icon="edit" size="sm" className={loading ? 'cursor-pointer' : ''} onClick={onTagsEdit}/>
        <CustomIcon icon="close" size="sm" className={loading ? 'cursor-pointer' : ''} onClick={onTagDelete}/>
      </div>
    </div>
  );
};

export default BlogTag;